import useBranding from '../../hooks/useBranding'

const SectionHeading = props => {
	const customBranding = useBranding()
	return (
		<div className="text-center">
			<h2 className="shadow" style={{
				padding:'16px 32px',
				background:customBranding ? customBranding.backgroundColor : '#000C2D',
				color:customBranding ? customBranding.textColor : '#eee',
				borderRadius:'100px',
				display:'inline-block',
				margin:0,
				fontSize:'1.7em',
			}}>
				<i 
					style={{
						color:customBranding ? customBranding.textColor : '#00ff8c'
					}} 
					className={props.icon}
				></i> {props.children}
			</h2>
		</div>
	)
}

export default SectionHeading